var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.brand)?_c('section',{staticClass:"product-brand-content"},[_c('figure',[_c('img',{attrs:{"src":_vm.brand.file.uri}}),_c('figcaption',{domProps:{"textContent":_vm._s(_vm.brand.title)}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }